<template>
  <div class="parent_div">
    <dd-header />
    <h2 class="hakotan_title">搬入経路のご確認</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <section class="guide_section">
            <div class="guide_msg">
              搬入の際に「廊下の天井に当たって運べない」「角を曲れない」などの家の構造や家具の大きさにより
              目的の部屋まで搬入できない場合がございます。
              事前に廊下の幅や天井までの高さなどのサイズや障害物がないか搬入経路のご確認のうえ、商品のご注文
              をしてください。
            </div>
            <div class="route_item_area">
              <div class="step_text">①商品サイズを確認</div>
              <div class="step_msg">
                はじめに、家具サイズ（幅、高さ、奥行き）をご確認ください。そして「梱包サイズ」を考慮して、
                家具サイズの天地左右＋100㎜以上の余裕を持って判断してください。 搬入にあたり、扉や廊下など
                の通路には、家具の横幅以上の高さが必要です。また、搬入経路の幅は、家具の幅、高さ、奥行きの
                うち一番短い寸法より大きい寸法でないと運べません。
              </div>
              <div class="route_img">
                <img :src="getImage('guide/route_1.png')">
              </div>
            </div>
            <div class="route_item_area">
              <div class="step_text">②搬入経路の確認箇所</div>
              <div class="step_msg">
                「玄関」「廊下」「階段」「エレベーター」「部屋の入口」の幅、高さ、奥行きをご確認ください。
                また、ドアノブや照明など、障害物がないかもご確認ください。
              </div>
              <div class="route_img">
                <img :src="getImage('guide/route_2.png')">
              </div>
            </div>
            <div class="route_item_area">
              <div class="step_text">③エレベーターのサイズ確認</div>
              <div class="step_msg">
                家具をエレベーターに乗せるためには、入口と内部の大きさが家具より大きくなくてはいけません。
                家具の幅、高さ、奥行きのうち、一番長い寸法が入口の高さより小さく、一番短い寸法が内部の奥行
                より小さければエレベーターに乗せることができます。
              </div>
              <div class="route_img">
                <img :src="getImage('guide/route_3.png')">
              </div>
            </div>
            <div class="route_item_area">
              <div class="step_text">④階段のサイズ確認</div>
              <div class="step_msg">
                搬入で一番難しいのは階段です。特に踊り場では商品を立てられる高さが必要です。
                「階段の幅・高さ」「踊り場の幅、高さ、奥行き」をご確認ください。
              </div>
              <div>
                <div class="route_size_img">
                  <div>
                    <img :src="getImage('guide/route_4-1.png')">
                  </div>
                  <div>
                    <img :src="getImage('guide/route_4-2.png')">
                  </div>
                </div>
              </div>
            </div>
            <div class="route_item_area">
              <div class="route_entrance_size">
                <div>
                  <div class="step_text">⑤玄関・共用通路のサイズ確認</div>
                  <div class="step_msg">
                    玄関と共用通路は玄関ドア周辺を確認してください。「廊下の幅・高さ」「玄関入口の幅・高さ」
                    「玄関内部の幅・高さ・奥行き」が確保されていれば運ぶことができます。
                    ドアノブや天井の照明なども考慮してください。
                  </div>
                </div>
                <div>
                  <img :src="getImage('guide/route_5-1.png')">
                </div>
              </div>
              <div class="step_msg route_entrance">
                玄関入り口では、特に以下の2点に注意しましょう。
              </div>
              <div class="entrance_item_area">
                <div class="entrace_item">
                  <div>
                    <div class="step_area_title">
                      <div></div>
                      <div>扉に引っかかる場合あります</div>
                    </div>
                    <div class="step_area_msg">
                      家具を扉の前に運ぶと扉を開けることができず、扉を開けると家具が通らなくなる場合もありますので
                      ご注意ください。
                    </div>
                  </div>
                  <div>
                    <img :src="getImage('guide/route_5-2.png')">
                  </div>
                </div>
              </div>
              <div class="entrance_item_area">
                <div class="entrace_item">
                  <div>
                    <div class="step_area_title">
                      <div></div>
                      <div>家具が回転できない場合あります</div>
                    </div>
                    <div class="step_area_msg">
                      扉を開くことができても、廊下の幅、入り口の幅が狭く搬入できない場合もありますのでご注意ください。
                    </div>
                  </div>
                  <div>
                    <img :src="getImage('guide/route_5-3.png')">
                  </div>
                </div>
              </div>
            </div>
            <div class="route_item_area">
              <div class="step_text">⑥室内廊下のサイズ確認</div>
              <div class="step_msg">
               「廊下の幅・天井までの高さ」「入り口の幅・高さ」「扉を開いた時のドアノブなどの突起物」「照明などの突起物」を確認してください。
              </div>
              <div class="route_img">
                <img :src="getImage('guide/route_6-1.png')">
              </div>
              <div class="route_hall_area">
                <div class="route_hall_item">
                  <div>
                    <div class="step_area_title">
                      <div></div>
                      <div>曲り角の運び方</div>
                    </div>
                    <div class="step_area_msg">
                      廊下に曲り角がある場合は、家具を縦にして回転させ搬入を行ってください。
                      室内のドアノブ等の突起物などが搬入時に障害となるものにご注意ください。
                    </div>
                  </div>
                  <div>
                    <img :src="getImage('guide/route_6-2.png')">
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu
  },
  data () {
    return {
      pageKey: 'DcRouteConfirm'
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getYasumokuResource(image)
    }
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>
<style src="../css/dc-guide.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcRouteConfirm.vue